import React from 'react';
import PropTypes from 'prop-types';
import {MainTitle} from '../Questions/Components/MainTitle';
import {AnimationSlider} from '@learningblocks/storybook-components';
import './style.scss';

export function SliderImage(props) {
  return (
    <div className='sliderQuestion'>
      <MainTitle title={props.headTitle} className='sliderQuestion_title' />
      <div className='sliderQuestion_content'>
        <h5 className='sliderImage_question'>{props.title}</h5>
        <AnimationSlider
          src={props.src}
          loading={props.loading}
          orientation={props.orientation}
          sliderValue={props.sliderValue}
          currentFrame={props.currentFrame}
          className='sliderImage_sliderblock'
          onSliderChange={props.onSliderChange}
          animationLoaded={props.animationLoaded}
        />
      </div>
    </div>
  );
}

SliderImage.propTypes = {
  /**
   * Text to display on top of widget
   */
  headTitle: PropTypes.string,
  /**
   * Main title of widget
   */
  title: PropTypes.string,
  /**
   * The animation file to be rendered
   */
  src: PropTypes.shape({
    /**
     * Boolean specifying if animations provided are url-path or animation-json
     */
    isPath: PropTypes.bool,
    /**
     * animation file for wide orientation
     */
    wide: PropTypes.object,
    /**
     * animation file for square orientaions
     */
    square: PropTypes.object,
  }),
  /**
   * Properties specific to the input-slider
   */
  sliderValue: PropTypes.shape({
    /**
     * Scale interval to display rulers
     */
    scaleInterval: PropTypes.number,
    /**
     * min value to set on slider
     */
    min: PropTypes.number,
    /**
     * max value to set on slider
     */
    max: PropTypes.number,
    /**
     * update step value for slider
     */
    step: PropTypes.number,
    /**
     * Current frame to render
     */
    current: PropTypes.number,
  }),
  /**
   * Callback for when slider thumb in moved
   */
  onSliderChange: PropTypes.func,
  /**
   * aria-label for the animation
   */
  ariaLabel: PropTypes.string,
  /**
   * Callback for when animation Finished loading
   */
  animationLoaded: PropTypes.func,
  /**
   * Boolean set to show content loaders on AnimationBlocks & SliderBlock
   */
  loading: PropTypes.bool,
  /**
   * Current frame to display ( to override sliderValue.current )
   */
  currentFrame: PropTypes.number,
  /**
   * The orientation for the animation
   */
  orientation: PropTypes.oneOf(['wide', 'square']),
};

SliderImage.defaultProps = {
  orientation: 'wide',
  headTitle: 'Explore',
  ariaLabel: '',
};
